module.exports = "/_next/static/images/down-9cb2fa3897e33bd13e9c83cc6a18b354.svg";